import { defineMessages } from 'react-intl';

export default defineMessages({
  branchesTab: {
    id: 'frontbucket.repository.source.refSelector.branchesTab',
    description: 'Label for the tab to select branches',
    defaultMessage: 'Branches',
  },

  filterBranches: {
    id: 'frontbucket.repository.source.refSelector.filterBranches',
    description: 'Input placeholder for filtering branches',
    defaultMessage: 'Filter branches',
  },

  filterTags: {
    id: 'frontbucket.repository.source.refSelector.filterTags',
    description: 'Input placeholder for filtering tags',
    defaultMessage: 'Filter tags',
  },

  loadMore: {
    id: 'frontbucket.repository.source.refSelector.loadMore',
    description:
      'Label for the link that loads more refs when there are more to load.',
    defaultMessage: 'Load more',
  },

  noRefSelected: {
    id: 'frontbucket.repository.source.refSelector.noRefSelected',
    description: 'Message displayed in the ref picker when no ref is selected',
    defaultMessage: 'Select a ref',
  },

  noResultsBranches: {
    id: 'frontbucket.repository.source.refSelector.noResultsBranches',
    description:
      'Message displayed in the ref picker when there are no branches matching the search term',
    defaultMessage: "We can't find branches with that name.",
  },

  tagsEmptyState: {
    id: 'frontbucket.repository.source.refSelector.tagsEmptyState',
    description: 'Message displayed in the ref picker when there are no tags',
    defaultMessage: 'There are no tags in this repository.',
  },

  noResultsTags: {
    id: 'frontbucket.repository.source.refSelector.noResultsTags',
    description:
      'Message displayed in the ref picker when there are no tags matching the search term',
    defaultMessage: "We can't find tags with that name.",
  },

  refSourceLabel: {
    id: 'frontbucket.repository.source.refSelector.refBranchLabel',
    description:
      'Screen reader only text is used to clarify that the button next text is name of selected reference',
    defaultMessage: 'source:',
  },

  tagsTab: {
    id: 'frontbucket.repository.source.refSelector.tagsTab',
    description: 'Label for the tab to select tags',
    defaultMessage: 'Tags',
  },
});
